import React from 'react'
import cn from 'classnames'
import WithTooltip from 'components/shared/WithTooltip'
import styles from 'components/panels/stream-order.module.scss'
import { SONG_ORDERS } from './radioArtistsModel'
import { setMusicPanelView, useMusicPanelView } from './musicPanelView'

const ORDER_ICONS = { plays: 'fa fa-arrow-up fa-large', recent: 'fa fa-clock-o' }

// The songs order row on a music profile, in the shared stream-order look:
// Top (most played) / New (most recently played).
export default function ArtistSongsOrder({ panelId }: { panelId: string }) {
    const { songOrder } = useMusicPanelView(panelId)

    return (
        <div className={styles.streamOrderComp}>
            <div className={styles.orderBtnContainer}>
                {SONG_ORDERS.map(option => (
                    <div key={option.key}>
                        <WithTooltip tip={option.tip}>
                            <button
                                type="button"
                                style={{ fontFamily: 'inherit', cursor: 'pointer' }}
                                aria-pressed={songOrder === option.key}
                                className={cn(
                                    styles.orderBtn,
                                    songOrder === option.key && styles.selected,
                                )}
                                onClick={() =>
                                    setMusicPanelView(panelId, { songOrder: option.key })
                                }
                            >
                                <i className={ORDER_ICONS[option.key]} />
                                <span className={styles.orderLabel}>{option.label}</span>
                            </button>
                        </WithTooltip>
                    </div>
                ))}
            </div>
        </div>
    )
}
